// extracted by mini-css-extract-plugin
module.exports = {"popover":"_983556a","tip":"_9bf6451","container":"_077d429","scroll":"_c442b32"};